import { useCallback, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from 'react-aria-components';
import { invalidFormValue, hasOwnPropertyTS } from '@components/utils';
import { DispatchPoint } from '@api/types/DispatchPoint';
import { DpdDispatchPoint } from '@pages/order/payment-shipping/dpd-script/DpdDispatchPoint';



type DpdScriptProps = {
	dispatchPoint: DispatchPoint | null;
	showInvalids: boolean;
	updateDispatchPoint: (value: DispatchPoint | null) => void;
}


export const DpdScript = (props: DpdScriptProps) => {
	const { dispatchPoint, showInvalids, updateDispatchPoint } = props;
	const { t } = useTranslation('forms');

	const dialogRef = useRef<HTMLDialogElement>(null);

	const handleMessageEvent = (event: MessageEvent) => {
		if(event.data.dpdWidget && hasOwnPropertyTS(event.data.dpdWidget, 'pickupPointResult')) {
			let point = event.data.dpdWidget as DpdDispatchPoint & Record<string, unknown>;
			if (!point) return;
			
			updateDispatchPoint({
				id: point.id ? point.id : '-',
				name: point.pickupPointResult ? point.pickupPointResult : '-',
				place: point.contactInfo && point.contactInfo.name ? point.contactInfo.name : '-',
				street: point.location && point.location.address && point.location.address.street ? point.location.address.street : '-',
				city: point.location && point.location.address && point.location.address.city ? point.location.address.city : '-',
				zip: point.location && point.location.address && point.location.address.zip ? point.location.address.zip : '-',
				country: point.location && point.location.address && point.location.address.country ? point.location.address.country : '-',
				url: point.contactInfo && point.contactInfo.web ? point.contactInfo.web : '-',
			});
			closeModal();
			return;
		}
		if(event.data.dpdWidget && event.data.dpdWidget.message === "widgetClose") {
			closeModal();
			return;
		} 
	};
	
	
	useEffect(() => {
		window.addEventListener('message', handleMessageEvent);
		return () => {
			window.removeEventListener('message', handleMessageEvent);
		}
	}, []);


	const showModal = useCallback(() => {
		if (dialogRef && dialogRef.current) {
			dialogRef.current.showModal();
		}
	},[ dialogRef ]);

	
	const closeModal = useCallback(() => {
		if (dialogRef && dialogRef.current) {
			dialogRef.current.close();
		}
	},[ dialogRef ]);


	return (
		<>
			<label className='dispatch-point-label'>
				{t('paymentShipping.shipping.dispatchPointLabel') + ': '}<span>*</span> {showInvalids && invalidFormValue(dispatchPoint) &&
					<p className='form-invalid'>{t('validation.requiredField')}</p>}
			</label>

			<div className='dispatch-point-text'>
				
				<p>{dispatchPoint ? `${dispatchPoint.place}, ${dispatchPoint.street}, ${dispatchPoint.city}` : t('paymentShipping.shipping.notSelect')}</p>

				<Button className='app-form-button disable-selection' autoFocus={false} onPress={() => {
					showModal();
				}}>
					{dispatchPoint ? t('shared.change') : t('shared.select')}
				</Button>

			</div>

			<dialog id="dpdDispatchPointModal" className='dpd-dispatch-modal' ref={dialogRef}>
				<iframe src="https://api.dpd.cz/widget/latest/index.html"></iframe>
			</dialog>
		</>
	);
};